module.exports = __webpack_public_path__ + "static/media/arjun-kapur.082c864e.png";